function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import * as S from './Dialog.styles';
const Dialog = ({
  open,
  title,
  icon,
  children,
  actions,
  onClickInside,
  dataTestId,
  ...rest
}) => /*#__PURE__*/React.createElement(S.Root, _extends({
  "data-testid": dataTestId,
  open: open,
  onClick: onClickInside,
  icon: !!icon,
  onClose: e => {
    rest?.onClose(e, 'escapeKeyDown');
    e.stopPropagation();
  }
}, rest), /*#__PURE__*/React.createElement(S.DialogIcon, null, icon), /*#__PURE__*/React.createElement(S.DialogTitle, null, title), /*#__PURE__*/React.createElement(S.DialogContent, null, children), /*#__PURE__*/React.createElement(S.DialogActions, null, actions));
export default Dialog;